
<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" mask-close @close="dialogFormEditConfirm($refs.form, arguments)">
		<c-form ref="form" column="2" vertical unit-width="100%">
			<c-form link-parent>
                <c-form-item label="售后申请单" required>
                    <c-select v-model="applyId" ref="orderSelect" name="apply_id" async :disabled="!!source" :clear="false" @search="searchOrder" @change="changeOrder"></c-select>
                    <info-card code="AFTERSALE_APPLY" :id="applyId"></info-card>
                </c-form-item>
                <c-form-item label="紧急程度" required>
                    <c-radio-group name="urgency_level" :options="urgencyLevelDic"></c-radio-group>
                </c-form-item>
                <c-form-item label="客户服务地址" required>
                    <template #handle>
                        <c-link v-if="applyId" @click="openCustomerAddressSelector">选择客户地址</c-link>
                    </template>
                    <div class="customer-address-row">
                        <c-location lng-name="customer_address_longitude" lat-name="customer_address_latitude" address-name="customer_address_detail" @updateLngLat="val => endPoint = val"></c-location>
                    </div>
                </c-form-item>
                <c-form-item label="售后网点" required>
				    <c-select ref="outletSelect" name="after_sale_outlet_id" async :clear="false" @search="searchOutlet" @change="changeOutlet"></c-select>

                    <template #tip>
                        <p v-if="expenses.customer_distance" style="color: #999;">距客户{{expenses.customer_distance}}公里，{{distanceTipWord}}</p>
                    </template>
                </c-form-item>
                <c-form-item label="预计服务时长" required>
				    <c-input v-model="expenses.estimated_service_days" type="stepper" name="estimated_service_days" :range="[1,Infinity]" append-text="天"></c-input>
                </c-form-item>
                <c-form-item label="预计住宿天数" required>
                    <c-input v-model="expenses.accommodation_days" type="stepper" name="accommodation_days" :range="[0,Infinity]" append-text="晚"></c-input>
                </c-form-item>
                <c-form-item label="预计上门人数" required>
				    <c-input v-model="expenses.estimated_technician_count" type="stepper" name="estimated_technician_count" :range="[1,Infinity]" append-text="人"></c-input>
                </c-form-item>
                <c-form-item label="客户预约时间" required>
				    <c-datetime v-model="expenses.appointment_start_time" type="date" name="appointment_start_time"></c-datetime>
                </c-form-item>
                <c-form-item label="是否使用机台" required>
                    <c-select v-model="expenses.use_machine" name="use_machine" :options="useMachineOptions"></c-select>
                </c-form-item>
                <c-form-item label="出行方式" required>
                    <c-select v-model="expenses.travel_mode" name="travel_mode" :options="travelModeOptions" @change="({value}) => expenses.public_travel_cost = value == 2 ? '' : '0'"></c-select>
                </c-form-item>
                <c-form-item v-show="expenses.travel_mode == 2" label="公共交通费用" required>
                    <c-input v-model="expenses.public_travel_cost" name="public_travel_cost" type="number" decimal="2" :range="[0,Infinity]" append-text="元"></c-input>
                </c-form-item>
                <c-form-item v-show="status === 0 || status === 1" label="需求描述">
                    <c-input type="textarea" name="demand_description" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item v-show="status === 0 || status === 1" label="必备技能" tip="执行该工单的售后工程师必须具备以下技能">
                    <c-select ref="skillSelect" name="require_skills" async multiple @search="searchRequireSkills"></c-select>
                </c-form-item>
                <c-form-item v-show="status === 0 || status === 1" label="星级要求" tip="执行该工单的工程师最低星级要求">
                    <c-select name="require_star_level" :options="starLevelDic"></c-select>
                </c-form-item>
                <c-form-item v-show="status === 0 || status === 1" label="现场图">
                    <c-upload-file name="scene_images" type="image" multiple="5" button="请选择图片" media></c-upload-file>
                </c-form-item>
			</c-form>

            <dl class="expenses">
                <dt class="flex-between-center">
                    <p>预估成本：</p>
					<strong>￥{{expensesDetail.estimated_cost_total || '-'}}</strong>
                </dt>
				<dd v-if="expensesDetail.estimated_cost_list.length">
					<ul>
						<li v-for="(item, i) in expensesDetail.estimated_cost_list" :key="i" class="flex-between-center">
							<span>{{item.fee_type_name}}：</span>
							<span>￥{{item.amount}}</span>
						</li>
					</ul>
                </dd>
            </dl>

			<c-title>售后服务明细</c-title>
			<c-form-item :label="false" name="product_list" colspan="3">
                <c-table ref="productListTable" border :paging="false">
                    <c-table-column label="存货编码" width="100">
                        <template #default="{data}">
                            <span>{{data.product_code}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="存货名称" width="120">
                        <template #default="{data}">
                            <span>{{data.inventory_name}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="规格型号" width="120">
                        <template #default="{data}">
                            <span>{{data.spec_model}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="长(mm)" width="80">
                        <template #default="{data}">
                            <span>{{data.length}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="宽(mm)" width="80">
                        <template #default="{data}">
                            <span>{{data.width}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="数量" width="80">
                        <template #default="{data}">
                            <span>{{data.quantity}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="件数" width="80">
                        <template #default="{data}">
                            <span>{{data.pieces}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="环接方式" width="100">
                        <template #default="{data}">
                            <span>{{data.connection_method}}</span>
                        </template>
                    </c-table-column>

                    <c-table-column label="备注" width="150">
                        <template #default="{data}">
                            <span>{{data.item_remark}}</span>
                        </template>
                    </c-table-column>
                </c-table>
            </c-form-item>
		</c-form>

        <customer-address-selector ref="customerAddressSelector" @confirm="onCustomerAddressPicked"></customer-address-selector>

        <template #button>
            <c-button v-if="status === 0" size="form" @click="submitHandle(0)">暂存草稿</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">提交数据</c-button>
        </template>
	</c-dialog>
</template>

<script>
	import {mapState} from 'vuex';
    import customerAddressSelector from '@/components/service/customer_address_selector.vue';

    export default {
        name: 'aftersaleOrderEdit',

        components: {
            customerAddressSelector
        },

        props: {
			id: Number,
			source: Number
        },

		data() {
			return {
                status: '',
				applyId: '',
                customerId: '',
				startPoint: '',
				endPoint: '',

				expenses: {
                    customer_duration: 0,
					customer_distance: 0,
					estimated_service_days: '',
					accommodation_days: 0,
					estimated_technician_count: '',
					appointment_start_time: '',
					use_machine: '',
					travel_mode: '',
					public_travel_cost: ''
				},
				expensesDetail: {
					holiday_days: '',
					estimated_cost_total: '',
					estimated_cost_list: []
				}
			}
		},
        computed: {
            ...mapState(['urgencyLevelDic', 'useMachineOptions', 'travelModeOptions', 'starLevelDic','userInfo']),

            distanceTipWord() {
                let sec = parseInt(this.expenses.customer_duration);
                let hours = sec / 3600;
                return '驾车预计耗时' + hours.toFixed(1) + '小时';
            }
        },

        watch: {
            applyId(val) {
                if (val) {
                    this.request({
                        url: '/aftersale/apply/detail',
                        data: {
                            id: val
                        },
                        success: ({detailInfo, itemList}) => {
                            this.customerId = detailInfo.customer_id || '';
                            this.$refs.productListTable.setData(itemList || []);
                        }
                    });
                } else {
                    this.customerId = '';
                    this.$refs.productListTable.setData([]);
                }
            },

			startPoint() {
				this.getDistance();
			},

			endPoint() {
				this.getDistance();
			},

			expenses: {
				handler(data) {
					this.expensesDetail = {
						holiday_days: '',
						estimated_cost_total: '',
						estimated_cost_list: []
					};
					this._expensesRequest && this._expensesRequest.abort();
					if (!Object.keys(data).find(key => !data[key] && data[key] !== 0)) {
						this._expensesRequest = this.request({
							url: '/after/sale/order/cal/fee',
							data,
							success: data => {
								this.expensesDetail = data;
							}
						});
					}
				},
				deep: true
			}
        },

		methods: {
			open() {
                this.status = 0;
                this.customerId = '';
                this.startPoint = this.endPoint = '';
                this.$refs.form.clear();
                
                if (this.id) {
                    this.request({
                        url: '/after/sale/order/detail',
                        data: {
                            id: this.id
                        },
                        success: ({detailInfo}) => {
                            this.status = detailInfo.status;
                            this.$refs.form.set(detailInfo);
                            this.$refs.orderSelect.setValueData([{
                                name: `${detailInfo.apply_order_code} | ${detailInfo.service_type == 2 ? '售后' : '售前'}`,
                                value: detailInfo.apply_id
                            }]);
                            this.$refs.outletSelect.setValueData([{
                                name: detailInfo.after_sale_outlet_name,
                                value: detailInfo.after_sale_outlet_id
                            }]);
                            
                            if (detailInfo.require_skills) {
                                this.$refs.skillSelect.setValueData(detailInfo.require_skills.split(',').map(item => {
                                    return {
                                        name: item,
                                        value: item
                                    }
                                }));
                            }

                            if (detailInfo.after_sale_outlet_longitude && detailInfo.after_sale_outlet_latitude) { 
                                this.startPoint = `${detailInfo.after_sale_outlet_longitude},${detailInfo.after_sale_outlet_latitude}`;
                            }
                            this.expenses.customer_distance = detailInfo.customer_distance;
                        }
                    })
                } else if (this.source) {
                    this.request({
                        url: '/aftersale/apply/detail',
                        data: {
                            id: this.source
                        },
                        success: ({detailInfo, itemList}) => {
                            this.$refs.form.set({
                                urgency_level: 1,
                                accommodation_days: 0,
                                customer_address_longitude: detailInfo.address_longitude,
                                customer_address_latitude: detailInfo.address_latitude,
                                customer_address_detail: detailInfo.aftersale_address,
                                appointment_start_time: detailInfo.eost_date ? detailInfo.eost_date.split(' ')[0] : '',
                                demand_description: [
                                    detailInfo.service_content ? `服务内容：${detailInfo.service_content}` : '',
                                    detailInfo.remark ? `备注：${detailInfo.remark}` : ''
                                ].filter(item => item).join('\n')
                            });
                            this.$refs.orderSelect.setValueData([{
                                name: `${detailInfo.aftersale_apply_no} | ${detailInfo.service_type_code == 2 ? '售后服务' : '售前服务'}`,
                                value: detailInfo.id
                            }]);
                        }
                    });
                } else {
                    this.$refs.form.set({
                        urgency_level: 1,
                        accommodation_days: 0,
                    });
                }

				this.$refs.dialog.open({
					title: this.id ? '编辑售后工单' : '创建售后工单'
				});
			},
            
			searchOrder(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_APPLY',
						keyword: keyword,
						order_id: 0,
                        outlet_id: this.userInfo.outlet_id
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: `${item.data.aftersale_apply_no} | ${item.data.service_type == 2 ? '售后服务' : '售前服务'}`,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			changeOrder(data) {
				this.$refs.form.set({
					customer_address_longitude: data.data.address_longitude,
					customer_address_latitude: data.data.address_latitude,
					customer_address_detail: data.data.aftersale_address,
					appointment_start_time: data.data.eost_date ? data.data.eost_date.split(' ')[0] : '',
					demand_description: [
						data.data.service_content ? `服务内容：${data.data.service_content}` : '',
						data.data.remark ? `备注：${data.data.remark}` : ''
					].filter(item => item).join('\n')
				});
			},

			searchOutlet(keyword, resolve) {
				this.request({
					url: '/system/options',
					data: {
						options_code: 'AFTERSALE_OUTLET',
						keyword: keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.data.outlet_name,
								value: item.data.id,
								data: item.data
							}
						}));
					}
				})
			},

			changeOutlet(data) {
				if (data.data.longitude && data.data.latitude) { 
					this.startPoint = `${data.data.longitude},${data.data.latitude}`;
				}
			},

			getDistance() {
				if (!this.startPoint || !this.endPoint) {
					this.expenses.customer_distance = 0;
				} else {
					this.request({
						url: '/location/distance',
						data: {
							longitude1: this.startPoint.split(',')[0],
							latitude1: this.startPoint.split(',')[1],
							longitude2: this.endPoint.split(',')[0],
							latitude2: this.endPoint.split(',')[1]
						},
						success: data => {
							this.expenses.customer_distance = data.distance;    //驾车-客户距离
							this.expenses.customer_duration = data.duration;    //驾车-预计时间（秒）
						}
					});
				}
			},

            openCustomerAddressSelector() {
                if (!this.customerId) {
                    this.$message({
                        message: '当前申请单未关联客户档案，无法选择常用地址',
                        type: 'warning'
                    });
                    return;
                }
                this.$refs.customerAddressSelector.open(this.customerId);
            },

            onCustomerAddressPicked(data) {
                this.$refs.form.set({
                    customer_address_longitude: data.longitude,
                    customer_address_latitude: data.latitude,
                    customer_address_detail: data.address_detail || ''
                });
            },

            /*******搜索工程师技能*****************/
            searchRequireSkills(keyword, resolve){
                this.request({
                    url:'/system/options',
                    data: {
                        options_code: 'DIC_INFO',
                        dic_code: 'SKILL',
                        keyword: keyword
                    },
                    success:data => {
                        data = data.map(item => {
                            var obj = {};
                            obj.value = item.name;
                            obj.name = item.name;
                            return obj;
                        });
                        resolve(data);
                    }
                })
            },

			/*******提交编辑数据********************/
			submitHandle(status) {
                if (this.order_id!=0 && this.order_status == 2 && this.schedule_start_time!=''){
                    //查询工单排期时间是否存在冲突
                    this.request({
                        url:'/after/sale/order/dispatch/conflict',
                        data:{
                            order_id:this.order_id,
                            estimated_service_days:this.estimated_service_days
                        },
                        success: (data, res) => {
                            if(data == 1){
                                this.$confirm({
                                    zIndex: 9999,
                                    type: 'warn',
                                    title: '排期冲突',
                                    message: res,
                                    buttonName: '继续修改',
                                    cancelButtonName: '取消修改',
                                    resolve: () => {
                                        this.dealSubmitHandle(status);
                                    },
                                    cancel: () => {
                                    }
                                })
                            }else {
                                this.dealSubmitHandle(status);
                            }
                        }
                    });
                }else {
                    this.dealSubmitHandle(status);
                }
			},
            
			dealSubmitHandle(status) {
				this.$refs.form.submit({
					url: this.id ? '/after/sale/order/edit' : '/after/sale/order/add',
					rule: {
                        apply_id: '请选择售后申请单',
                        urgency_level: '请选择紧急程度',
                        customer_address_longitude: '请选择客户地址',
                        customer_address_latitude: '请选择客户地址',
                        customer_address_detail: '请填写客户详细地址',
                        after_sale_outlet_id: '请选择售后网点',
                        estimated_service_days: '请填写预计服务时长',
						accommodation_days: '请填写预计住宿天数',
                        estimated_technician_count: '请填写预计上门人数',
                        appointment_start_time: '请选择客户预约时间',
                        use_machine: '请选择是否使用机台',
                        travel_mode: '请选择出行方式',
						public_travel_cost: [{
							type: 'empty',
							message: '请填写公共交通费用',
							skip: () => {
								return this.expenses.travel_mode != 2;
							}
						}]
					},
					dataFormatter: data => {
                        data.id = this.id;
						data.status = status;
						data.estimated_cost_total = this.expensesDetail.estimated_cost_total;
						data.estimated_cost_json = JSON.stringify(this.expensesDetail);
						data.customer_distance = this.expenses.customer_distance || 0;
						data.customer_duration = this.expenses.customer_duration || 0;
						return data;
					},
					success: () => {
						this.$message({
							message: '提交成功'
						});
                        this.$refs.dialog.close();
						this.$emit('resolve');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
.customer-address-row
    width 100%
    .c-button
        margin-bottom 8px

    
	.expenses {
        width: 100%;
		border-radius: 8px;
		padding: 0 20px;
		margin-top: 10px;
		background: #F9F9F9;

		dt {
			height: 50px;
			
			p {
				font-size: 16px;
				font-weight: bold;
			}

			strong {
				font-size: 18px;
				color: #FF0000;
			}
		}

		dd {
			padding-bottom: 15px;

			li {
				height: 24px;
				font-size: 13px;
				color: #999;
			}
		}
	}
</style>